module.exports = __webpack_public_path__ + "img/overlay-video-team.f5cc348.png";